import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Product } from '../models/product.interface';
import { Region } from '../models/region.interface';
import { Destination } from '../models/destination.interface';
import { SharedModule } from '../shared.module';
import { Order } from '../models/order.interface';
import { Itinerary } from '../models/itinerary.interface';

const _log: boolean = false;

@Injectable({providedIn: SharedModule})
export class StorageService {
	constructor(
		private _cookieService: CookieService
	) {}

	//NOTE: EVERYTHING IS SET TO STRING TO NORMALIZE. stringify/parse JSON in specific methods

	//COOKIE STORAGE - https://github.com/stevermeister/ngx-cookie-service
	private _cset(key: string, value: string, expiry: number = 7, path: string = '/') {
		this._cookieService.set(key, value, expiry, path);
		return this;
	}
	private _cget(key: string) {
		const cVal = this._cookieService.get(key);
		//console.log('_cget:', key, '=', cVal);
		return cVal;
	}
	private _cunset(key: string, path: string = '/') {
		this._cookieService.delete(key, path);
		return this;
	}

	//LOCAL STORAGE
	private _lset(key: string, value: string) {
		localStorage.setItem(key, value);
		return this;
	}
	private _lget(key: string) {
		return localStorage ? localStorage.getItem(key) : null;
	}
	private _lunset(key: string) {
		localStorage.removeItem(key);
		return this;
	}

	//SESSION STORAGE
	private _sset(key: string, value: string) {
		sessionStorage.setItem(key, value);
		return this;
	}
	private _sget(key: string) {
		return sessionStorage.getItem(key);
	}
	private _sunset(key: string) {
		sessionStorage.removeItem(key);
		return this;
	}
	


	/**
	 * sign out of site, clear storage
	 * Needed to specifically unset locally, in addition to clear/deleting
	*/
	public signOut() {
		//console.log('StorageService.signOut()');
		this.unSetCart();
		//this.unSetOrder();//shouldn't storing this anymore
		localStorage.clear();
		sessionStorage.clear();
		this._cookieService.deleteAll();
	}



	//Cookie Banner
	public cookieBanner: boolean = false;
	public keyCookieBanner: string = 'cookieBanner';
	public setCookieBanner(cookieBanner: boolean) {
		this.cookieBanner = cookieBanner;
		this._cset(this.keyCookieBanner, JSON.stringify(this.cookieBanner), 365);
	}
	public getCookieBanner() {
		const cookieBanner = this._cget(this.keyCookieBanner);
		//console.log('getCookieBanner.cookieBanner:', cookieBanner);
		this.cookieBanner = (cookieBanner) ? JSON.parse(cookieBanner) : cookieBanner;
		return this.cookieBanner;
	}
	public unSetCookieBanner() {
		this.cookieBanner = null;
		this._cunset(this.keyCookieBanner);
		//console.log('unSetCart.cookieBanner:', this.cookieBanner);
	}


	//FAVORITES
	public favs: any[];//model TBD
	public keyFavs: string = 'favs';
	public setFavorites(favs: any[]) {
		this.favs = favs;
		this._cset(this.keyFavs, JSON.stringify(this.favs), 365);
	}
	public getFavorites() {
		const favs = this._cget(this.keyFavs);
		//console.log('getFavs.favs:', favs);
		this.favs = (favs) ? JSON.parse(favs) : favs;
		return this.favs;
	}


	//CART
	public cart: any;//model TBD
	public keyCart: string = 'cart';
	public setCart(cart: any) {
		this.cart = cart;
		this._cset(this.keyCart, JSON.stringify(this.cart), 30);
	}
	public getCart() {
		const cart = this._cget(this.keyCart);
		//console.log('getCart.cart:', cart);
		//buggy carts cause it to become stringified undefined
		this.cart = (cart && cart != 'undefined') ? JSON.parse(cart) : null;
		//console.log('StorageService.getCart.cart:', this.cart);
		return this.cart;
	}
	public unSetCart() {
		this.cart = null;
		this._cunset(this.keyCart);
		//console.log('unSetCart.cart:', this.cart);
	}


	//PAYMENT/ORDER
	public order: Order;//model TBD
	public keyOrder: string = 'order';
	public setOrder(order: Order) {
		this.order = order;
		this._cset(this.keyOrder, JSON.stringify(this.order), 30);
		//console.log('setOrder.order:', JSON.stringify(this.order));
	}
	public getOrder() {
		const order = this._cget(this.keyOrder);
		//console.log('getOrder.order:', order);
		this.order = (order) ? JSON.parse(order) : null;
		return this.order;
	}
	public unSetOrder() {
		this.order = null;
		this._cunset(this.keyOrder);
	}



	//Product
	public productRDP: Product;//model TBD
	public keyProductRDP: string = 'product';
	public setProductRegDestProdSlug(regionSlug: string, destinationSlug: string, idOrSlug: string, product: Product) {
		//console.log('setProduct.product:', product);
		this.productRDP = product;
		const keyName = this.keyProductRDP + '-' + regionSlug + '-' + destinationSlug + '-' + idOrSlug;
		this._sset(keyName, JSON.stringify(this.productRDP));
	}
	public getProductRegDestProdSlug(regionSlug: string, destinationSlug: string, idOrSlug: string) {
		const keyName = this.keyProductRDP + '-' + regionSlug + '-' + destinationSlug + '-' + idOrSlug;
		const product = this._sget(keyName);
		//console.log('getProduct.product:', product);
		this.productRDP = (product) ? JSON.parse(product) : product;
		return this.productRDP;
	}
	public unsetProductRegDestProdSlug() {
		const keys = Object.keys(sessionStorage);
		//console.log('clearProduct:', keys);
		keys.forEach(key => {
			//console.log('key:', key.slice(0,8), key);
			if(key.slice(0,8) == this.keyProductRDP) {
				this._sunset(key);
			}
		});
		
	}


	//Product
	public product: Product;//model TBD
	public keyProduct: string = 'product';
	public setProduct(idOrSlug: string, product: Product) {
		//console.log('setProduct.product:', product);
		this.product = product;
		this._sset(this.keyProduct + '-' + idOrSlug, JSON.stringify(this.product));
	}
	public getProduct(idOrSlug: string) {
		const product = this._sget(this.keyProduct + '-' + idOrSlug);
		//console.log('getProduct.product:', product);
		this.product = (product) ? JSON.parse(product) : product;
		return this.product;
	}
	public unsetProduct() {
		const keys = Object.keys(sessionStorage);
		//console.log('clearProduct:', keys);
		keys.forEach(key => {
			//console.log('key:', key.slice(0,8), key);
			if(key.slice(0,8) == this.keyProduct) {
				this._sunset(key);
			}
		});
		
	}




	//Region
	public region: Region;//model TBD
	public keyRegion: string = 'region';
	public setRegion(regionSlug: string, region: Region) {
		//console.log('setRegion.region:', region);
		this.region = region;
		this._sset(this.keyRegion + '-' + regionSlug, JSON.stringify(this.region));
	}
	public getRegion(regionSlug: string) {
		const region = this._sget(this.keyRegion + '-' + regionSlug);
		//console.log('getRegion.region:', region);
		this.region = (region) ? JSON.parse(region) : region;
		return this.region;
	}
	public unsetRegion() {
		const keys = Object.keys(sessionStorage);
		//console.log('clearRegion:', keys);
		keys.forEach(key => {
			//console.log('key:', key.slice(0,8), key);
			if(key.slice(0,8) == this.keyRegion) {
				this._sunset(key);
			}
		});
		
	}




	//Destination
	public destination: Destination;//model TBD
	public keyDestination: string = 'destination';
	public setDestination(destinationSlug: string, destination: Destination) {
		//console.log('setDestination.destination:', destination);
		this.destination = destination;
		this._sset(this.keyDestination + '-' + destinationSlug, JSON.stringify(this.destination));
	}
	public getDestination(destinationSlug: string) {
		const destination = this._sget(this.keyDestination + '-' + destinationSlug);
		//console.log('getDestination.destination:', destination);
		this.destination = (destination) ? JSON.parse(destination) : destination;
		return this.destination;
	}
	public unsetDestination() {
		const keys = Object.keys(sessionStorage);
		//console.log('clearDestination:', keys);
		keys.forEach(key => {
			//console.log('key:', key.slice(0,8), key);
			if(key.slice(0,8) == this.keyDestination) {
				this._sunset(key);
			}
		});
		
	}





	//Itinerary
	public itinerary: Itinerary;
	public keyItinerary: string = 'itinerary';
	public setItinerary(itinerary: Itinerary) {
		this.itinerary = itinerary;
		this._lset(this.keyItinerary, JSON.stringify(this.itinerary));
		//console.log('setItinerary.itinerary:', JSON.stringify(this.itinerary));
	}
	public getItinerary() {
		const itinerary = this._lget(this.keyItinerary);
		//console.log('getItinerary.itinerary:', itinerary);
		this.itinerary = (itinerary) ? JSON.parse(itinerary) : null;
		//console.log('getItinerary.itinerary:', this.itinerary);
		return this.itinerary;
	}
	public unSetItinerary() {
		this.itinerary = null;
		this._lunset(this.keyItinerary);
	}



	//Destination Date Search
	public destDateSearch: any;
	public keyDestDateSearch: string = 'destDateSearch';
	public setDestDateSearch(destDateSearch: any) {
		this.destDateSearch = destDateSearch;
		this._sset(this.keyDestDateSearch, JSON.stringify(this.destDateSearch));
		//console.log('setItinerary.destDateSearch:', JSON.stringify(this.destDateSearch));
	}
	public getDestDateSearch() {
		const destDateSearch = this._sget(this.keyDestDateSearch);
		//console.log('getItinerary.destDateSearch:', destDateSearch);
		this.destDateSearch = (destDateSearch) ? JSON.parse(destDateSearch) : null;
		//console.log('getItinerary.destDateSearch:', this.destDateSearch);
		return this.destDateSearch;
	}
	public unDestDateSearch() {
		this.destDateSearch = null;
		this._sunset(this.keyDestDateSearch);
	}



	//Customer Referral Code from Travel Advisor
	public referralCode: any;
	public keyReferralCode: string = 'referralCode';
	public setReferralCode(referralCode: any) {
		this.referralCode = referralCode;
		this._sset(this.keyReferralCode, JSON.stringify(this.referralCode));
		//console.log('setItinerary.referralCode:', JSON.stringify(this.referralCode));
	}
	public getReferralCode() {
		const referralCode = this._sget(this.keyReferralCode);
		//console.log('getItinerary.referralCode:', referralCode);
		this.referralCode = (referralCode) ? JSON.parse(referralCode) : null;
		//console.log('getItinerary.referralCode:', this.referralCode);
		return this.referralCode;
	}
	public unReferralCode() {
		this.referralCode = null;
		this._sunset(this.keyReferralCode);
	}

}